goog.provide('el8.multiuser_access.setup');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.setup = (function() {

    var that = {};
    that.init = function(targetForm) {
        $.el8_ajaxOpts['processResponseFn'] = function(xhr, textStatus, data, err, msg, requestInfo) {
            // Get the Response Code
            if (xhr) {
                switch(xhr.status) {
                    /** Good news **/
                    case 200: // Great!
                        break;
                    case 409: // Conflict
                    case 404: // Page not found
                    case 400: // Bad request; server couldn't understand
                    case 403: // Forbidden; no permission
                    case 500: // Internal server error
                        location.href="/efax/error/";
                        break;
                    default:  // Assume this is an internet issue
                        break;
                }
            }
        };  
    };

    return that;

})();